import camelCase from 'lodash.camelcase';

import isObject from './isObject';

const camelizeKeys = (object: Record<string, unknown>) => Object
  .keys(object)
  .reduce((result, key) => {
    const item = object[key];
    const camelizedKey = camelCase(key);
    if (isObject(item)) {
      return {
        ...result,
        [camelizedKey]: camelizeKeys(item),
      };
    }
    return {
      ...result,
      [camelizedKey]: item,
    };
  }, {});

export default camelizeKeys;
